import { render } from "./tabbar.vue?vue&type=template&id=2d6984db&scoped=true"
import script from "./tabbar.vue?vue&type=script&lang=js"
export * from "./tabbar.vue?vue&type=script&lang=js"

import "./tabbar.vue?vue&type=style&index=0&id=2d6984db&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6984db"]])

export default __exports__